"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCreatorService = void 0;
class SearchCreatorService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Search for creators information.
     * @param requestBody
     * @returns SearchCreatorsReaponse
     * @throws ApiError
     */
    searchCreators(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/search/creators/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns available search creator fields information
     * @returns SearchField
     * @throws ApiError
     */
    getSearchCreatorFields() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search/creators/fields',
        });
    }
    /**
     * Returns value suggestions for provided input
     * @param field
     * @param term
     * @returns any Successful response
     * @throws ApiError
     */
    getSearchCreatorFieldTerms(field, term) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search/creators/fields/{field}/{term}',
            path: {
                'field': field,
                'term': term,
            },
        });
    }
}
exports.SearchCreatorService = SearchCreatorService;
